import React from 'react';
import { Drawer, Popover } from '@mantine/core';
import { useIsPhone } from '@/hooks/use.responsive';

type Props = {
    opened: boolean;
    onClose: () => void;
    target: React.ReactElement;
    label: string;
    align?: 'start' | 'end';
    children: React.ReactNode;
};

const FilterSurface: React.FC<Props> = ({ opened, onClose, target, label, align = 'start', children }) => {
    const isPhone = useIsPhone();

    if (isPhone) {
        return (
            <>
                {target}
                <Drawer
                    opened={opened}
                    onClose={onClose}
                    position="bottom"
                    size="auto"
                    withCloseButton={false}
                    padding={0}
                    radius="lg"
                    aria-label={label}
                    styles={{ content: { maxHeight: '88dvh', display: 'flex', flexDirection: 'column' }, body: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', maxHeight: '88dvh' } }}
                >
                    {children}
                </Drawer>
            </>
        );
    }

    return (
        <Popover
            opened={opened}
            onChange={(next) => { if (!next) onClose(); }}
            position={align === 'end' ? 'bottom-end' : 'bottom-start'}
            width={340}
            shadow="lg"
            radius="md"
            trapFocus
            returnFocus
            withinPortal
            transitionProps={{ transition: align === 'end' ? 'pop-top-right' : 'pop-top-left', duration: 150 }}
        >
            <Popover.Target>{target}</Popover.Target>
            <Popover.Dropdown p={0} style={{ maxHeight: 'min(70vh, 34rem)', display: 'flex', flexDirection: 'column' }} aria-label={label}>
                {children}
            </Popover.Dropdown>
        </Popover>
    );
};

export default FilterSurface;
